import { useTranslation } from 'react-i18next'

import { StorefrontIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'

import StoresTable from './StoresTable/StoresTable'
import { storesDescriptions } from './constants'
import * as Styles from './styles'

const StoresMetricsCard = ({ stores, loading, tableFilters, onChangeTableFilters, salesOrdersDataActivated }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const description = salesOrdersDataActivated ? storesDescriptions.withSalesData : storesDescriptions.withoutSalesData

  const handleSort = value => {
    if (onChangeTableFilters) {
      const filterValueWithOrdering = tableFilters?.ordering === value ? `-${value}` : value
      onChangeTableFilters({ ...tableFilters, ordering: filterValueWithOrdering })
    }
  }

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={theme.spacing.sp16}>
        <Styles.Title>
          <StorefrontIcon />
          {t('Tiendas')}
        </Styles.Title>
      </CardTitle>
      <CardDescription>{t(description)}</CardDescription>
      <StoresTable loading={loading} stores={stores} onSort={handleSort} orderBy={tableFilters?.ordering} />
    </Card>
  )
}

export default StoresMetricsCard
